import { api } from '@/scripts/api';
import { helpers } from '@/scripts/helpers';

const LOCAL_THEME_KEY = 'gh_theme';
const DATA_ATTRIBUTE_THEME = 'data-theme';

export const THEME_NAME = {
    Light: 'light',
    Dark: 'dark'
};

export const THEMES = [
    {
        label: 'Light',
        value: THEME_NAME.Light
    },
    {
        label: 'Dark',
        value: THEME_NAME.Dark
    }
];

export const DEFAULT_THEME_NAME = THEME_NAME.Light;

export function isValidThemeName(themeName) {
    return THEMES.find(theme => theme.value === themeName) != null;
}

function getLocalTheme() {
    return localStorage.getItem(LOCAL_THEME_KEY);
}

function storeLocalTheme(themeName) {
    localStorage.setItem(LOCAL_THEME_KEY, themeName);
}

function deleteLocalTheme() {
    localStorage.removeItem(LOCAL_THEME_KEY);
}

function applyTheme(themeName) {
    if(!isValidThemeName(themeName)) {
        themeName = DEFAULT_THEME_NAME;
    }

    document.documentElement.setAttribute(DATA_ATTRIBUTE_THEME, themeName);
}

export const theme = {
    namespaced: true,

    state: (() => ({
        themeName: DEFAULT_THEME_NAME
    })),

    mutations: {
        setTheme(state, themeName) {
            if(!isValidThemeName(themeName)) {
                themeName = DEFAULT_THEME_NAME;
            }

            storeLocalTheme(themeName);
            applyTheme(themeName);
            state.themeName = themeName;
        }
    },

    actions: {
        unloadTheme({ commit }) {
            deleteLocalTheme();
            commit('setTheme', DEFAULT_THEME_NAME);
        },

        loadTheme({ commit, rootState, rootGetters }) {
            let currentThemeName = getLocalTheme();

            if(!currentThemeName) {
                currentThemeName = DEFAULT_THEME_NAME;
                storeLocalTheme(currentThemeName);
            }

            if(!isValidThemeName(currentThemeName)) {
                deleteLocalTheme();
                storeLocalTheme(DEFAULT_THEME_NAME);
            }

            commit('setTheme', currentThemeName);

            if(!rootGetters.isOrganizationUser || !rootState.isLoggedIn) {
                return Promise.resolve();
            }

            return api
                .get('/ms/configs/v1/users?where=[{"Type": {"$eq": "theme"}}]')
                .then((res) => {
                    const data = res.data.data[0];
                    if(data && data.Config) {
                        const config = JSON.parse(data.Config);
                        const themeName = config.theme;

                        commit('setTheme', themeName);
                    }
                })
                .catch((error) => {
                    helpers.showFailNotification(
                        'Failed to load theme',
                        { error }
                    )
                });
        },

        saveTheme({ rootState, rootGetters }, themeName) {
            if(!rootGetters.isOrganizationUser || !rootState.isLoggedIn) {
                return Promise.resolve();
            }

            const payload = {
                Type: 'theme',
                Config: JSON.stringify({
                    theme: themeName,
                }),
            };

            return api
                .post('/ms/configs/v1/users', payload)
                .then(() => {
                    helpers.showSuccessNotification('Theme updated successfully');
                })
                .catch((error) => {
                    helpers.showFailNotification(
                        'Failed to update theme',
                        { error }
                    )
                });
        }
    },
};